import { Component, OnInit, computed, inject } from '@angular/core';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterOutlet,
} from '@angular/router';
import { environment } from 'environments/environment.prod';
import { Meta } from '@angular/platform-browser';
import { LoadingService } from './shared/service/loading.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, MatProgressSpinnerModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: true,
})
export class AppComponent implements OnInit {
  private loadingService = inject(LoadingService);
  private router = inject(Router);
  loading = computed(() => this.loadingService.loading());
  private meta = inject(Meta);
  title = 'kccyberdefense-angular';
  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.loadingService.show();
      }

      if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this.loadingService.hide();
      }
    });
    if (environment.disableIndexing) {
      this.meta.addTag({ name: 'robots', content: 'noindex, nofollow' });
    }
  }
}
